<template>
  <v-btn class="normal-btn-text elevation-0 rounded-tag-small ml-2"
         :loading="loadingPdf"
         @click="gerarPdf">
    <v-icon>mdi-file-pdf-box</v-icon>
    Gerar PDF
  </v-btn>
</template>

<script>
import RelatoriosService from '@/api/relatorios-service';
import { TipoRelatorio } from 'px-business-components';

export default {
  props: {
    venda: Object,
  },
  data() {
    return {
      loadingPdf: false,
    };
  },
  methods: {
    gerarPdf() {
      this.loadingPdf = true;
      const payload = {
        tipoRelatorio: TipoRelatorio.keys.ORDEM_COMPRA_FORNECEDOR.key,
        arguments: {
          idCompra: this.venda.id,
        },
      };
      return RelatoriosService.generateReport(this.venda.comprador.id, payload)
        .then(({ data }) => {
          window.open(data.reportUrl);
        })
        .finally(() => {
          this.loadingPdf = false;
        });
    },
  },
};
</script>
